export default {
    fields:[
        {
            key: "fieldMappingId",
            label:"field",
            sorter: false,
            filter: false,
        },
        {
            key: "fieldMappingValue",
            label:"name",
            sorter: false,
            filter: false,
        },
        {
            key: "fieldMappingMethod",
            label:"method",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label:"options",
            sorter: false,
            filter: false,
            _style: 'width:10%',
            _classes: "text-center"
        },
    ],
    items:[]
}